exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-mask[data-v-52a5cac9]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:table;transition:opacity .3s ease}.modal-wrapper[data-v-52a5cac9]{display:table-cell;vertical-align:middle}.modal-container[data-v-52a5cac9]{width:700px;margin:0 auto;padding:20px 30px;background-color:#fff;border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,.33);transition:all .3s ease;font-family:Helvetica,Arial,sans-serif}.modal-header h3[data-v-52a5cac9]{margin-top:0}.modal-body[data-v-52a5cac9]{margin:20px 0;height:400px;overflow:auto}.modal-footer[data-v-52a5cac9]{margin-top:30px;padding-top:30px;border-top:1px solid #d3d3d3;text-align:right}.modal-default-button[data-v-52a5cac9]{float:right}.modal-enter[data-v-52a5cac9],.modal-leave-active[data-v-52a5cac9]{opacity:0}.modal-enter .modal-container[data-v-52a5cac9],.modal-leave-active .modal-container[data-v-52a5cac9]{transform:scale(1.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-52a5cac9&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/MessageModal.vue
// module id = 205
// module chunks = 0